import isNil from 'lodash/isNil';
import isUndefined from 'lodash/isUndefined';
import {asyncStorage} from '../../config/constants';


/**
 * Responsible for caching:
 * PROFILE
 * TOKEN
 * FIREBASE_TOKEN
 * REFRESH_TOKEN
 * POST_AUTH_STATE_KEY
 * device_push_token
 */
export class AuthCacheService {
  static SERVICE_NAME = 'authCacheService';

  constructor() {
    this.localStorage = global.window.localStorage;
    this.asyncStorage = asyncStorage;
  }

  getItem(key) {
    if (this.localStorage) {
      let lsError = null;
      let b = void 0;
      // Try to get the value. Otherwise, store that we got an error.
      try {
        b = this.localStorage.getItem(key);
        if (!isNil(b)) {
          b = JSON.parse(b);
        }
      } catch (e) {
        lsError = e;
      }

      try {
        return this.asyncStorage.getItem(key)
        // If both operations succeed, return the result from the one that has a value.
          .then(a => {
            // If either value exists, return it.
            if (isNil(b)) {
              return a;
            } else {
              return b;
            }

          })
          // Check if only one or both operations failed. If localStorage succeeded, return that value instead.
          .catch(e => {
            if (lsError) {
              return Promise.error(lsError);
            } else if (isNil(b)) {
              return Promise.error(e);
            } else {
              return b;
            }
          });
      } catch (e) {
        if (lsError) {
          return Promise.error(lsError);
        } else if (!this.localStorage) {
          return Promise.error(e);
        } else {
          return Promise.resolve(void 0);
        }
      }
    } else {
      return this.asyncStorage.getItem(key);
    }
  }

  setItem(key, value) {
    return this.op(driver => {
      if (driver === this.localStorage && !isUndefined(value)) {
        return driver.setItem(key, JSON.stringify(value));
      } else {
        return driver.setItem(key, value);
      }
    });
  }

  removeItem(key) {
    return this.op(driver => driver.removeItem(key));
  }

  /**
   * Only throw an exception if both operations fail.
   * Do not throw syncronous exceptions, only return exceptional promises.
   * @param fn
   * @returns {*}
   * @private
   */
  op(fn) {
    let lsError = null;

    if (this.localStorage) {
      try {
        fn(this.localStorage);
      } catch (e) {
        lsError = e;
      }
    }

    try {
      return fn(this.asyncStorage)
        .catch(e => {
          if (lsError) {
            return Promise.error(lsError);
          } else if (!this.localStorage) {
            return Promise.error(e);
          } else {
            return void 0;
          }
        });
    } catch (e) {
      if (lsError) {
        return Promise.error(lsError);
      } else if (!this.localStorage) {
        return Promise.error(e);
      } else {
        return Promise.resolve(void 0);
      }
    }
  }
}

export const authCacheService = new AuthCacheService();



// WEBPACK FOOTER //
// ./src/js/auth/services/AuthCacheService.js